// extracted by mini-css-extract-plugin
export default {"review":"schola-review_review__NWSYc","review_star_text":"schola-review_review_star_text__MsBd+"};